var _path, _path2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTelepresence(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40,36.75A8.75,8.75,0,1,0,31.25,28,8.75967,8.75967,0,0,0,40,36.75Zm0-16A7.25,7.25,0,1,1,32.75,28,7.258,7.258,0,0,1,40,20.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25,56V68a.7502.7502,0,0,0,.75.75h8a.74932.74932,0,0,0,.71094-.5127L21.21069,60.75H58.78931l2.49975,7.4873A.74932.74932,0,0,0,62,68.75h8a.7502.7502,0,0,0,.75-.75V15.9165A2.7122,2.7122,0,0,0,68,13.25H12a2.7122,2.7122,0,0,0-2.75,2.6665Zm60,11.25H62.54l-2.16943-6.5H68a2.78342,2.78342,0,0,0,1.25-.30493ZM10.75,15.9165A1.21176,1.21176,0,0,1,12,14.75H68a1.21176,1.21176,0,0,1,1.25,1.1665V51.25H52.75V46.46143A7.00018,7.00018,0,0,0,46,39.25H34a7.00018,7.00018,0,0,0-6.75,7.21143V51.25H10.75Zm40.5,30.54493V51.25H28.75V46.46143A5.5017,5.5017,0,0,1,34,40.75H46A5.5017,5.5017,0,0,1,51.25,46.46143ZM10.75,56V52.75h58.5v5.3335A1.21176,1.21176,0,0,1,68,59.25H12a1.21176,1.21176,0,0,1-1.25-1.1665Zm0,4.44507A2.78342,2.78342,0,0,0,12,60.75h7.62939L17.46,67.25H10.75Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 20,
    r: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTelepresence);
export default __webpack_public_path__ + "static/media/icon_telepresence.f1b92511f70d016884e9d5c67de65ffb.svg";
export { ForwardRef as ReactComponent };